import React from 'react'
import { CloseIcon } from '~/assets/svg'
import { getLocalizedVal } from '~/tools/localization/helpers'



class Upgrade extends React.Component {
  render() {
    return (
      <div className="upgrade-prompt">
        <div className="upgrade-overlay">
          <div onClick={this.props.toggleUpgrade}> <CloseIcon /></div>
          {getLocalizedVal(window.settings,'genericMessages', 'featureRestrictUpgradeMsg')}
          <button className="upgrade-button cta" onClick={()=> (window.location = "/user")}>{getLocalizedVal(window.settings,'genericMessages', 'upgradeNow')}</button>
        </div>
      </div>
    )
  }
}

export default Upgrade